<template>
  <v-container fluid>
    <v-card
      class="mx-auto"
    >
      <v-card-text>
        
      <div>{{textoCatalogoInstitucional}}</div>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col v-if="isCampus" cols="12" md="4" :offset-md="mdOffsetCampus">
            <select-campus :id-campus-prop="idCampus" :fn-change="setCampus" :requerido="false" :consulta="consulta"></select-campus>
          </v-col>
          <v-col v-if="isDivision" cols="12" md="4">
            <select-division :id-campus="idCampus" :id-division-prop="idDivision" :fn-change="setDivision" :requerido="false" :consulta="consulta"></select-division>
          </v-col>
          <v-col v-if="isDepartamento" cols="12" md="4">
            <select-dep-plan-unidad :id-campus="idCampus" :id-division="idDivision" :id-dep-plan-unidad-prop="idDepartamento" :fn-change="setDepartamento" :requerido="false" :consulta="consulta"></select-dep-plan-unidad>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

export default {
  name: 'CatInsEncuesta',
  components: {
    SelectCampus: () => import("../comunes/SelectCampus"),
    SelectDivision: () => import("../comunes/SelectDivision"),
    SelectDepPlanUnidad: () => import("../comunes/SelectDepPlanUnidad"),     
  },
  props: {
    isCampus: {
      type: Boolean,
      default: false
    },
    idCampus: {
      type: String,
      default: null
    },
    setCampus: {
      type: Function,
      required: true
    },
    isDivision: {
      type: Boolean,
      default: false
    },
    idDivision: {
      type: String,
      default: null
    },
    setDivision: {
      type: Function,
      required: true
    },
    isDepartamento: {
      type: Boolean,
      default: false
    },  
    idDepartamento: {
      type: String,
      default: null
    },    
    setDepartamento: {
      type: Function,
      required: true
    },
    consulta: {
      type: Boolean,
      required: true
    },
    vistaPrevia: {
      type: Boolean,
      default: false
    },
    idEncuesta:{
      type:Number,
      default:0
    },
    textoCatalogoInstitucional:{
      type: String,
      default: null
    },
  },
  data: () => ({
    snackbar: false,
    snackbarColor: '',
    snackbarTexto: '',
  }),
  computed: {
    mdOffsetCampus: function () {
      var value = "4";
      if(this.isDivision == true || this.isDepartamento == true){
        value = "2";

        if(this.isDepartamento == true){
          value = "0";
        }
      }
      return value;
    }
  },
  watch: { },
  beforeMount() {
  },
  methods: {
    
  },
};
</script>
